/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher error correction survives smudges, folds and logos.`)
};

const es_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una corrección de errores más alta resiste manchas, dobleces y logos.`)
};

const de_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhere Fehlerkorrektur übersteht Verschmutzungen, Falten und Logos.`)
};

const nl_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogere foutcorrectie overleeft vlekken, vouwen en logo's.`)
};

const fr_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une correction d'erreur plus élevée résiste aux taches, plis et logos.`)
};

const it_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una correzione errori più alta resiste a macchie, pieghe e loghi.`)
};

const pt_br2_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção de erro mais alta resiste a manchas, dobras e logos.`)
};

const pt_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma correção de erros mais alta sobrevive a manchas, dobras e logótipos.`)
};

const ja_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誤り訂正レベルを高くすると、汚れ、折れ、ロゴがあっても読み取れます。`)
};

const zh_qr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更高的纠错级别能承受污渍、折痕和徽标遮挡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ex2", locale)
	if (locale === "en") return en_qr_ex2(inputs)
	if (locale === "es") return es_qr_ex2(inputs)
	if (locale === "de") return de_qr_ex2(inputs)
	if (locale === "nl") return nl_qr_ex2(inputs)
	if (locale === "fr") return fr_qr_ex2(inputs)
	if (locale === "it") return it_qr_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ex2(inputs)
	if (locale === "pt") return pt_qr_ex2(inputs)
	if (locale === "ja") return ja_qr_ex2(inputs)
	return zh_qr_ex2(inputs)
};